import script from "./SalaryVoucherTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryVoucherTemplate.vue?vue&type=script&setup=true&lang=js"

import "./SalaryVoucherTemplate.vue?vue&type=style&index=0&id=0a47af0c&lang=less&scoped=true"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a47af0c"]])

export default __exports__